<template>
  <b-form @submit.prevent="sendEmail">
    <b-card class="border0">
      <b-row>
        <b-col class="col-6">
          <label>ID</label>
          <b-form-input
            ref="userId"
            v-model="userid"
            trim
            pattern=".{1,20}"
            title="최대 20자 이하로 입력해주세요"
            required
          ></b-form-input>
        </b-col>
        <b-col class="col-6" style="justify-content: flex-start;">
          <b-button class="chkIdBtn" @click="checkId" :disabled="isCheckUserId || !(userid != null && userid.length > 0)">중복확인</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>비밀번호</label>
          <b-form-input
            type="password"
            v-model="userpw"
            trim
            pattern=".{1,100}"
            title="최대 100자 이하로 입력해주세요"
            @input="checkPw"
            required
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>비밀번호 확인</label>
          <b-form-input
            ref="userpwchk"
            type="password"
            v-model="userpwchk"
            trim
            pattern=".{1,100}"
            title="최대 100자 이하로 입력해주세요"
            @input="checkPw"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row v-if="pwMismatch" class="pwAlertMsg">
        <b-col class="col-6">
          <span>비밀번호가 일치하지 않습니다.</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>이름</label>
          <b-form-input
            v-model="username"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
            required
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>전화번호</label>
          <b-form-input
            v-model="mobilenum"
            trim
            pattern="^\d{3}-\d{4}-\d{4}$"
            title="ex) 010-1234-5678"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>이메일</label>
          <b-form-input
            v-model="email"
            trim
            pattern="^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$"
            title="ex) abc@naver.com"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>회사 명</label>
          <b-form-input
            v-model="companyname"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
          ></b-form-input>
          <!-- <b-form-select
            v-model="compid"
            :options="companyOptions"
            @change="chgCompany"
          ></b-form-select> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>회사 부서</label>
          <b-form-input
            v-model="companydept"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>회사 직위</label>
          <b-form-input
            v-model="companypos"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>회사 전화번호</label>
          <b-form-input
            v-model="officetel"
            trim
            pattern="^\d{2,4}-\d{3,4}-\d{4}$"
            title="ex) 042-523-1111"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-regiBtn" type="submit" :disabled="!isCheckUserId || pwMismatch"
          ><i class="fa fa-check-circle"></i>신청</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import utils from "./utils";

export default {
  computed: {
    ...mapGetters(["getUserAuth", "getAlertOptions", "getConfirmOptions"]),
  },
  props: {

  },
  data: () => ({
    userid: null,
    isCheckUserId: false,
    userpw: null,
    userpwchk: null,
    username: null,
    mobilenum: null,
    email: null,
    compid: null,
    companyname: null,
    companyOptions: [{ value: null, text: "선택" }],
    companydept: null,
    companypos: null,
    officetel: null,
    grade: "CT",
    smsyn: null,
    emailyn: null,
    approvalyn: "N",
    sensorAuthList: [],
    pwMismatch: false,
  }),
  created() {
    // this.getCompanyList();
  },
  watch: {
    userid: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isCheckUserId = false
      }
    },
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    getCompanyList() {
      this.$http
        .post("/system/getCompanyList")
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var value = [{ value: null, text: "선택" }];
            // 장비 상태
            var companyList = res.data.data;
            for (let i = 0; i < companyList.length; i++) {
              value.push({
                value: companyList[i].idx,
                text: companyList[i].name,
              });
            }
            this.companyOptions = value;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    checkId() {
      var reqBody = {
        userid: this.userid,
      };
      this.$http
        .post("comn/checkDuplId", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var count = res.data.data.count;
            if (count >= 1) {
              this.isCheckUserId = false;
              this.$refs.userId.focus();

              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(
                  "중복된 아이디입니다.",
                  this.getAlertOptions
                )
                .then((value) => {
                })
                .catch((err) => {
                  console.error(err);
                });
            } else {
              this.isCheckUserId = true;

              this.$bvModal.msgBoxOk(
                "사용 가능한 아이디입니다.",
                this.getAlertOptions
                )
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    checkPw() {
      if (this.userpwchk) {
        this.pwMismatch = this.userpw !== this.userpwchk;
      }
    },
    // chgCompany(idx) {
    //   for (let i = 1; i < this.companyOptions.length; i++) {
    //     if (this.companyOptions[i].value == idx) {
    //       this.companyname = this.companyOptions[i].text;
    //     }
    //   }
    // },
    sendEmail() {
      if (this.userpw !== this.userpwchk) {
        this.$bvModal
          .msgBoxOk(
            "비밀번호가 일치하지 않습니다.",
            this.getAlertOptions
          )
          .then((value) => {
            setTimeout(() => {
              this.$refs.userpwchk.focus();
            }, 500);
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        console.log("ITS 담당자에게 메일 전송");
        this.setConfirmTitle("확인");
        this.$bvModal
          .msgBoxConfirm("가입하시겠습니까?", this.getConfirmOptions)
          .then((value) => {
            if (value) {
              var reqBody = {
                userid: utils.chkStr(this.userid),
                userpw: this.userpw,
                username: utils.chkStr(this.username),
                mobilenum: utils.chkStr(this.mobilenum),
                email: utils.chkStr(this.email),
                companyname: utils.chkStr(this.companyname),
                compid: utils.chkNum(this.compid),
                companydept: utils.chkStr(this.companydept),
                companypos: utils.chkStr(this.companypos),
                officetel: utils.chkStr(this.officetel),
                grade: this.grade,
                // smsyn: this.smsyn,
                // emailyn: this.emailyn,
                approvalyn: this.approvalyn,
                sensorAuthList: this.sensorAuthList,
              };
              this.$http
                .post("/system/regiUserInfo", reqBody)
                .then((res) => {
                  if (res.data.resultyn === "Y") {
                    this.setAlertTitle("신청 완료");
                    this.$bvModal
                      .msgBoxOk("회원가입 신청이 완료되었습니다.", this.getAlertOptions)
                      .then((value) => {
                        this.closeModal();
                      })
                  } else {
                    this.setAlertTitle();
                    this.$bvModal
                      .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                      .then((value) => {})
                      .catch((err) => {
                        console.error(err);
                      });
                  }
                })
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    closeModal() {
      this.$bvModal.hide("joinModal");
    },
  },
}
</script>

<style lang="scss">
#joinModal .modal-dialog {
  max-width: 800px;

  .modal-content {

    .card {

      .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;

        .row {
          height: 50px;

          .col {
            padding: 10px 0;

            .chkIdBtn {
              background-color: #7367f0;
              border-color: #7367f0;
              padding: 6px 15px;
              color: #fff;
              border-radius: 5px;
            }

            &:first-child {
              padding-right: 10px;
            }
            &:last-child {
              padding-left: 10px;
            }
            &:only-child {
              padding-left: 0;
              padding-right: 0;
              &:not(.col-12) {
                padding-right: 10px;
              }
            }
            label {
              display: flex;
              align-items: center;
              width: 100px;
              height: 100%;
            }
          }
        }
        .pwAlertMsg {
          height: auto;
          justify-content: flex-end;

          .col {
            justify-content: flex-end;
            padding: 0;
            font-size: 12px;

            span {
              color: #ffa500;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/JoinModal.vue